import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { errorToast } from '../utils/errorHandling';
import { getAnnouncement } from '../services/studentApi';
import { Link } from 'react-router-dom';
import Button from '../components/Button/Button';

const base_url = process.env.REACT_APP_BASE_URL;

const HomeOnline = () => {
  const [announcement, setAnnouncement] = useState([]);
  const { t } = useTranslation();

  const fetchAnnouncement = async () => {
    try {
      const data = await getAnnouncement();
      if (data) {
        setAnnouncement(data);
      }
    } catch (error) {
      errorToast(error, "Action Failed. Please contact admin", t);
    }
  };

  useEffect(() => {
    fetchAnnouncement();
  }, []);

  return (
    <>
      <div className="welcome-banner">
        <h2>{t("Home.WelcomeOnline")}</h2>

        <p>{t("Home.OnlineDescription")}</p>
        <div className='action-buttons'>
          <Link to={`${base_url}/view_attendance`}>
            <Button buttonStyle="btn--primary">{t("Home.CheckAttendance")}</Button>
          </Link>
          <Link to={"https://us02web.zoom.us/j/88972678947?pwd=OyzxsEp6lYEgVVe8AaITYnvN37mrDL.1"} target="_blank" rel="noopener noreferrer">
            <Button buttonStyle="btn--primary">{t("Home.JoinZoom")}</Button>
          </Link>
        </div>
        <div>
          <p className='m-0'>{t("Home.ZoomId")}: <span style={{ color: "#4e73df" }}>889 7267 8947</span></p>
          <p className='m-0'>{t("Home.ZoomPassword")}: <span style={{ color: "#4e73df" }}>999999</span></p>
        </div>

      </div>

      <h4 className='homepage-title'>{t("Home.Announcement")}</h4>
      <div className='movingCard'>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            {announcement.filter(i => i.status === "1" && i.student_type === "Online").map((i, index) => (
              <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index === 0 ? "active" : ""} />
            ))}
          </div>
          <div className="carousel-inner">
            {announcement.filter(i => i.status === "1" && i.student_type === "Online").map((i, index) => (
              <div className={index === 0 ? "carousel-item active" : "carousel-item"} key={index}>
                <Link to={i.target_url || ""} target="_blank" rel="noopener noreferrer">
                  <div className="caption">
                    <h5 className='mb-0 mt-3'>☘️ {localStorage.getItem("i18nextLng") === "en" ? i.title_en : i.title_cn}</h5>
                    <p className='mb-0'> {localStorage.getItem("i18nextLng") === "en" ? i.description_en : i.description_cn}</p>
                  </div>
                  <img
                    src={i.image_url}
                    className="d-block w-100"
                    alt=""
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `${base_url}/images/poster.jpg`
                    }}
                  />
                </Link>
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <h4 className='homepage-title'>{t("Home.OnlineInstructions")}</h4>
      {localStorage.getItem("i18nextLng") === "en" ?
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGiIy0AYbk/LVJQ3C5TKmsJTgnMKSKu6A/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGiIy0AYbk&#x2F;LVJQ3C5TKmsJTgnMKSKu6A&#x2F;view?utm_content=DAGiIy0AYbk&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【Online Retreat Important Notice】2025 The 3rd Malaysian Satipatthana Meditation Retreat</a>
          </div>
        </>
        :
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGiAmnP3Bo/ynXNENCT1GBCxAzBenNkOg/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGiAmnP3Bo&#x2F;ynXNENCT1GBCxAzBenNkOg&#x2F;view?utm_content=DAGiAmnP3Bo&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【線上課程須知】2025大馬四念處禪修課程</a>
          </div>
        </>
      }
    </>
  )
}

export default HomeOnline 